document.addEventListener("DOMContentLoaded", function() {

    if(document.querySelector('.template-product')){
      const stickyATC = function(){
        const regularBtn = document.querySelector('.product-block form button');
       
        if(window.scrollY > regularBtn.offsetTop - 500){
          document.querySelector('.sticky-form').classList.add('show-form');
        }else{
          document.querySelector('.sticky-form').classList.remove('show-form');
        }
      }
      window.addEventListener('scroll', stickyATC);
      

        let atcBtn = document.querySelector('.sticy-atc');
        atcBtn.addEventListener('click', () => {
        document.querySelector('button.add-to-cart').click()
        });

    }




  });